import React from 'react';
import { Badge } from '@chakra-ui/react';
import { getBotArea, getAreaColorProps } from '../constants/botAreas';

interface BotAreaBadgeProps {
  botName: string;
}

export const BotAreaBadge: React.FC<BotAreaBadgeProps> = ({ botName }) => {
  const area = getBotArea(botName);

  if (!area) return null;

  const colorProps = getAreaColorProps(area.color);

  return (
    <Badge {...colorProps} fontSize="2xs">
      {area.label}
    </Badge>
  );
};
